import { SearchFormState } from '../reducers';

export const getSelectedFareGroup = (state: SearchFormState) => state.selectedFareGroup;
